import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages/HamesayatPage.tsx");
